module.exports = __webpack_public_path__ + "static/soubhagya-92d8eb969aeb9b098138732411fb2e3e.jpg";